import {
  DATE_ASYNC_FETCH,
  DATE_ASYNC_FETCH_SUCCESS,
  DATE_ASYNC_FETCH_FAILURE,
  DATE_ASYNC_FETCH_INVALIDATE,
  SET_SELECTED_TRAVEL_DATE
} from '../constants';

import httpClient, { getHttpClientRequest, postHttpClientRequest, isUnAuth } from "../../../shared/services/httpClient";
import apiUrl from '../../../shared/utilities/apiUrl';

export const getSections = (postData) => dispatch => {
  dispatch(asyncFetch());

  const onSuccess = response => {
    dispatch(asyncFetchSuccess(response.data,));
  };

  const onError = error => {
    dispatch(asyncFetchFailed(error));
  };
  const callMS = (postData) => {

    var axConfig = {
      headers: { pageName: "travelDate", subServiceName: "travelDate" }
    };
    let sApiUrl = isUnAuth() ? apiUrl().itptravelDatesUrl_ua : apiUrl().itptravelDatesUrl;
    console.log("Api url==" + sApiUrl);
    if (sApiUrl.indexOf("localhost") > -1) {
      return getHttpClientRequest(sApiUrl, axConfig);
    } else {
      return postHttpClientRequest(
        sApiUrl,
        postData,
        axConfig
      );
    }

  };

  callMS(postData)
    .then(msResp => {
      if (msResp && msResp.status == 200) {
        onSuccess(msResp);
      } else {
        onError(msResp);
      }
    })
    .catch(onError);
};

export const setSelectedTravelDateValue = data => ({
  type: SET_SELECTED_TRAVEL_DATE,
  data
});
export const asyncFetch = urlParams => ({
  type: DATE_ASYNC_FETCH,
  urlParams
});
export const asyncFetchSuccess = msResp => ({
  type: DATE_ASYNC_FETCH_SUCCESS,
  msResp,
  isFetching: false,
});
export const asyncFetchFailed = err => ({
  type: DATE_ASYNC_FETCH_FAILURE,
  err
});

